module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_06_6NX26_1SF_G9K.e0d7ead5.png";